module.exports = __webpack_public_path__ + "img/core.cea9325e.png";